import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.scss';
import "./tabs_switch.ui.scss";

interface ITabsSwitchProps {
    tabsItems: Array<string | null>;
    tabsStyle?: React.CSSProperties;
    tabsListStyle?: React.CSSProperties;
    tabsItemStyle?: React.CSSProperties;
    tabsPanels:Array<{
        label:string;
        component:() => React.ReactNode;
    } | null>;
    onTabChange?: (tab:number) => void;
    selectedTab?: number;
}

const TabsSwitch = (props: ITabsSwitchProps) => {
    const [selectedTabIndex, setSelectedTabIndex] = useState(props.selectedTab ?? 0);

    const handleSelect = (index:number) => {
        setSelectedTabIndex(index);
        if (props.onTabChange) {
            props.onTabChange(index);
        }
    }

    return (
        <Tabs style={props.tabsStyle} selectedIndex={props.selectedTab != undefined ? props.selectedTab : selectedTabIndex} onSelect={handleSelect}>
            <TabList style={props.tabsListStyle}>
                {props.tabsItems.map((item,index) => {
                    if (item) return <Tab key={index} style={props.tabsItemStyle}>{item}</Tab>
                })}
            </TabList>
            {props.tabsPanels.map((item:any,index:number) => {
                if (item) return <TabPanel key={index}>{item.component()}</TabPanel>
            })}
        </Tabs>
    )
}

export default TabsSwitch;